export interface UserSummary {
    userId: number;
    firstName?: string;
    lastName?: string;
    username?: string;
}

export interface ProformaIncome {
    proformaIncomeId?: number;
    label?: string;
    amount?: number;
    pct?: number;
    scenarioType?: string;
}

export interface ProformaExpense {
    proformaExpenseId?: number;
    label?: string;
    amount?: number;
    pct?: number;
}

export interface ProformaStatistics {
    grossRevTotal?: number;
    occupancyPct?: number;
    numNights?: number;
    avgNightlyRate?: number;
    mgmtFeeTotal?: number;
    netOwnerIncome?: number;
}

export class Proforma
{
	proformaId?: number;
	proformaDate?: Date;
	preparedDate?: Date;
	name?: string;
	description?: string;

	// Audit
	dbversion?: number;
	createDate?: string;
	lastUpdate?: string;
	createByUserVO?: UserSummary;

	// Relationships
	propertyProfileLeadVO?: { propertyLeadProfileId: number; subjAdrDevelopmentName?: string; subjAdrUnit?: string; subjAdrCity?: string; subjAdrState?: string };
	realtorProfileVO?: any;
	ownerProfileLeadVO?: any;
	proformaTemplateVO?: any;
	proformaIncomeVOList?: ProformaIncome[];
	proformaExpenseVOList?: ProformaExpense[];

	// Core fields
	confId?: string;
	status?: number;
	visibility?: number;
	mlsAllId?: number;

	// Revenue totals
	expandYrGrossTtl?: number;
	contractYrGrossTtl?: number;
	stableYrGrossTtl?: number;
	estGrossRev?: number;

	// Contract terms
	initialTermLengthMonths?: number;
	subsequentTermLengthMonths?: number;
	mgmtFeePCT?: number;
	freeDepartureCleanNUM?: number;
	freeCarDaysNUM?: number;
	signCreditAMT?: number;
	remodelCreditAMT?: number;
	upgradeCredit?: number;
	mgmtFeeCreditAMT?: number;
	otherCreditAMT?: number;
	termsSummaryDesc?: string;

	// Transient statistics
	expansion?: ProformaStatistics;
	stable?: ProformaStatistics;
	contraction?: ProformaStatistics;
	numNightsTtl?: number;
	targetTotal?: number;

	// Rev by month (EnumMap<Month, Double> serialized as object)
	stableRevByMonth?: { [month: string]: number };
	expansionRevByMonth?: { [month: string]: number };
	contractionRevByMonth?: { [month: string]: number };

	// Occupancy by month
	stableOccupByMonth?: { [month: string]: number };
	expansionOccupByMonth?: { [month: string]: number };
	contractionOccupByMonth?: { [month: string]: number };

	// Avg nightly rate by month
	stableAvgNgtRateByMonth?: { [month: string]: number };
	expansionAvgNgtRateByMonth?: { [month: string]: number };
	contractionAvgNgtRateByMonth?: { [month: string]: number };
}
